import { useEffect } from 'react';

type UseSyncConfigWhenAuthReadyParams<TConfig> = {
  loading: boolean;
  isAuthenticated?: boolean;
  config: TConfig | null;
  syncConfig: (config: TConfig) => void;
};

export function useSyncConfigWhenAuthReady<TConfig>({
  loading,
  isAuthenticated,
  config,
  syncConfig,
}: UseSyncConfigWhenAuthReadyParams<TConfig>): void {
  useEffect(() => {
    if (loading || !isAuthenticated || !config) {
      return;
    }

    syncConfig(config);
  }, [loading, isAuthenticated, config, syncConfig]);
}
